<template>
  <div class="wx-h5">
    <van-loading  color="#1989fa" vertical text-size="26" size="26"
      >页面跳转中...</van-loading
    >
  </div>
</template>
<script>
import config from '@/config'
import { setToken } from '@/utils/common'
import { fetchLogin } from '@/services/login'
export default {
  name: 'Login',
  data () {
    return {
      params: {},
    }
  },
  created () {
    this.getWxLogin()
  },
  mounted () {
    console.log('获取url参数', this.getUrlCode())
    this.params = this.getUrlCode()
    this.jumpLogin()
  },
  methods: {

    async jumpLogin () {
      var code = this.getUrlCode().code

      if (code) {
        this.getWxPublicGetUserOpenId()
      } else {
        // eslint-disable-next-line camelcase
        const redirect_uri = location.href // 回调的页面地址
        const appId = config.appid // 公众号的appid
        const newRedirect = encodeURIComponent(redirect_uri)
        console.log(redirect_uri, '==redirect_uri')
        location.href =
          'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
          appId +
          '&redirect_uri=' +
          newRedirect +
          '&response_type=code&scope=snsapi_userinfo#wechat_redirect'
      }
    },

    async getWxPublicGetUserOpenId () {
      const { data = {} } = await fetchLogin({ code: this.params.code })
      setToken(data.h5Token)
      const { page = '' } = this.params

      this.$router.push({ name: page === 'openVip' ? 'openVip' : 'buyFrequency' })
    },

    // 获取url中的code方法
    getUrlCode () {
      // 截取url中的code方法
      const url = location.search
      // eslint-disable-next-line no-new-object
      const theRequest = new Object()
      if (url.indexOf('?') != -1) {
        const str = url.substr(1)
        const strs = str.split('&')
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1]
        }
      }
      return theRequest
    },
  },
}
</script>

<style lang="scss">
.wx-h5 {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}
</style>
